import React from 'react';

import PulseMonitor from './PulseMonitor.js';
import { RESPIRATORY_RATE, respirationAmplitude } from './pulseModel.js';

const COLOR = [239, 237, 150];
const sample = (seconds) => 125 - 75 * respirationAmplitude(seconds);
const readout = () => RESPIRATORY_RATE;

const RespSketch = () => (
  <PulseMonitor
    label="RESP"
    className="resp"
    color={COLOR}
    sample={sample}
    readout={readout}
    initialValue={RESPIRATORY_RATE}
    valueId="resp-rate-value"
    unit="RR /min"
  />
);

export default RespSketch;
